<form class="card mt-2">
  <div class="card-body">
    <h2 class="mb-3">Referrals</h2>
    <div class="mb-3">
      <div class="row">
        <div class="col-xl-6 col-12">
          <div class="row">
            <div class="col-2 d-flex align-items-center">
              <h5>Referred By:</h5>
            </div>
            <div class="col-10">
              <div class="ml-2 w-100 mb-2">
                <p-autoComplete [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" [(ngModel)]="selectedReferredBy"
                                [suggestions]="userEmployeeList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                                [ngModelOptions]="{standalone: true}" [minLength]="1" [autoHighlight]="true"
                                (onSelect)="reloadListAfterReferredByStaffChage($event)" [forceSelection]="true"
                                (onClear)="reloadListAfterReferredByClear($event)"></p-autoComplete>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-2 d-flex align-items-center">
              <h5>New Hire:</h5>
            </div>
            <div class="col-10">
              <div class="ml-2 w-100 mb-2">
                <p-autoComplete [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" [(ngModel)]="selectedNewHire"
                                [suggestions]="userEmployeeList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                                [ngModelOptions]="{standalone: true}" [minLength]="1" [autoHighlight]="true"
                                (onSelect)="reloadListAfterNewHireStaffChage($event)" [forceSelection]="true"
                                (onClear)="reloadListAfterNewHireClear($event)"></p-autoComplete>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-2 d-flex align-items-center">
              <h5>Campus:</h5>
            </div>
            <div class="col-10">
              <i *ngIf="!campusList" class="material-icons rotate text-muted">loop</i>
              <p-dropdown styleClass="form-control ml-2 w-100 mb-2" [options]="campusList" [(ngModel)]="campusId" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-dropdown>
            </div>
          </div>

          <div class="row">
            <div class="col-2 d-flex align-items-center">
              <h5>From Next Bonus Date:</h5>
            </div>
            <div class="col-10">
              <input type="date" class="form-control ml-2 w-100 mb-2" [(ngModel)]="startDate" (blur)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}" />
            </div>
          </div>

          <div class="row">
            <div class="col-2 d-flex align-items-center">
              <h5>To Next Bonus Date:</h5>
            </div>
            <div class="col-10">
              <input type="date" class="form-control ml-2 w-100 mb-2" [(ngModel)]="endDate" (blur)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}" />
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-12">
          <div class="row mb-1">
            <div class="col-4 d-flex align-items-center">
              <h5>Show Prospective Candidates:</h5>
            </div>
            <div class="col-8 ">
              <p-selectButton styleClass="w-100 ml-2" [options]="yesNoAllOptions" [(ngModel)]="prospectiveCandidatesFilter" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-selectButton>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-4 d-flex align-items-center">
              <h5>Show Rejected Referrals:</h5>
            </div>
            <div class="col-8 ">
              <p-selectButton styleClass="w-100 ml-2" [options]="yesNoAllOptions" [(ngModel)]="rejectedReferralsFilter" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-selectButton>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-4 d-flex align-items-center">
              <h5>Show Archived Referrals:</h5>
            </div>
            <div class="col-8 ">
              <p-selectButton styleClass="w-100 ml-2" [options]="yesNoAllOptions" [(ngModel)]="archivedReferralsFilter" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-selectButton>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-4 d-flex align-items-center">
              <h5>Show Separated Users (Referred By):</h5>
            </div>
            <div class="col-8 ">
              <p-selectButton styleClass="w-100 ml-2" [options]="yesNoAllOptions" [(ngModel)]="terminatedEmployeesFilter" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-selectButton>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-4 d-flex align-items-center">
              <h5>Show Inactive Users (Referred By):</h5>
            </div>
            <div class="col-8 ">
              <p-selectButton styleClass="w-100 ml-2" [options]="yesNoAllOptions" [(ngModel)]="inactiveUsersFilter" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-selectButton>
            </div>
          </div>
        </div>

      </div>


    </div>

    <i [hidden]="!loadingList" class="material-icons rotate text-muted">loop</i>
    <button (click)="addNewReferral()" class="btn btn-secondary mr-2 mb-2">New Referral</button>
    <p-table [value]="list?.result" [responsive]="true" [paginator]="true" [rows]="20"
             [totalRecords]="list?.totalRecords" [lazy]="true" (onLazyLoad)="reloadFilter($event)">
      <ng-template pTemplate="header">
        <tr>
          <th width="150px"></th>
          <th [pSortableColumn]="'NewHire'">New Hire <p-sortIcon [field]="'NewHire'"></p-sortIcon></th>
          <th [pSortableColumn]="'ReferredBy'">Referred By <p-sortIcon [field]="'ReferredBy'"></p-sortIcon></th>
          <th [pSortableColumn]="'Campus'">Campus <p-sortIcon [field]="'Campus'"></p-sortIcon></th>
          <th>Oversight Scores</th>
          <th>Self Reviews</th>
          <th [pSortableColumn]="'OnActivePerformancePlan'">Active Performance Plan<p-sortIcon [field]="'OnActivePerformancePlan'"></p-sortIcon></th>
          <th [pSortableColumn]="'TrainingStartDate'">Training Start Date (Days after hire) <p-sortIcon [field]="'TrainingStartDate'"></p-sortIcon></th>
          <th [pSortableColumn]="'NextBonusDate'">Next Bonus Date<p-sortIcon [field]="'NextBonusDate'"></p-sortIcon></th>
          <th >Referral Bonus</th>
          <th width="150px">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-referral>
        <tr>
          <td>
            <div style="display: inline-flex;">
              <button *ngIf="canManage" class="btn btn-secondary mr-1" (click)="editReferral(referral)" title="Edit Referral">
                <i class="fas fa-pencil"></i>
              </button>
              <button *ngIf="canManage" class="btn btn-danger mr-1" (click)="deleteReferral(referral)" title="Delete Referral">
                <i class="fas fa-times-circle"></i>
              </button>
              <button *ngIf="hasSignedForm(referral)" class="btn btn-secondary mr-1" (click)="viewForm(referral)" title="View Form">
                <i class="fab fa-wpforms"></i>
              </button>
              <button *ngIf="showCreateFormButton(referral)" class="btn btn-secondary mr-1" (click)="createReferralForm(referral)" title="Create Form">
                <i class="fal fa-file-plus"></i>
              </button>
            </div>
            <span *ngIf="!hasSignedForm(referral)" style="font-style:italic; color: red; font-size: 0.8rem; display: inline-flex;">{{getFormDetails(referral)}}</span>
          </td>
          <td>
            <span class="ui-column-title">NewHire</span>
            {{referral.newHireLastName}}, {{referral.newHireFirstName}} <span style="font-style:italic; color: red; font-size: 0.8rem;">{{getNewHireDetailsString(referral)}}</span>
          </td>
          <td>
            <span class="ui-column-title">ReferredBy</span>
            {{referral.referredByLastName}}, {{referral.referredByFirstName}} <span style="font-style:italic; color: red; font-size: 0.8rem;">{{getReferredByTerminationString(referral)}}</span>
          </td>
          <td>
            <span class="ui-column-title">Campus</span>
            {{referral.newHirePrimaryCampus}}
          </td>
          <td>
            <span class="ui-column-title">Oversight Scores</span>
            <div *ngFor="let r of referral.lastOversightReviews">
              <span [attr.title]="getOversightReviewTitle(r)">
                {{r.oversightReviewDate | date: 'MM/dd/yyyy'}} - Score: {{r.oversightScore}}
              </span>
              <i *ngIf="r.maxScore !== null && r.maxScore < r.oversightScore" class="fas fa-stars" style="color: darkorange" [attr.title]="getOversightReviewScoreTitle(r)"></i>
              <i *ngIf="r.hasKraExceedingMaxScore" class="fal fa-star-exclamation" style="color: goldenrod" title="Has KRA exceeding max score"></i>
            </div>
          </td>
          <td>
            <span class="ui-column-title">Self Review Date</span>
            <div *ngFor="let r of referral.lastReviewPeriods">
              {{r.month}}
              <i *ngIf="r.completedAllTemplates" class="fas fa-check-circle text-success" title="Completed all required templates"></i>
              <i *ngIf="!r.completedAllTemplates" class="fas fa-times-circle text-danger" title="Did NOT complete all required templates"></i>
            </div>
          </td>
          <td>
            <span class="ui-column-title">Active Performance Plan</span>
            {{referral.newHireOnActivePerformancePlan ? "Yes" : "No"}}
          </td>
          <td>
            <span class="ui-column-title">Training Start Date</span>
            {{(referral.newHireTrainingStartDate !== null) ? (referral.newHireTrainingStartDate | date: 'MM/dd/yyyy') : ""}} <span style="font-style:italic; font-size: 0.8rem;" title="Days after hire">{{getNewHireDaysAfterHire(referral)}}</span>
          </td>
          <td>
            <span class="ui-column-title">Next Bonus Date</span>
            {{(referral.nextBonusDate !== null) ? (referral.nextBonusDate | date: 'MM/dd/yyyy') : ""}}
          </td>
          <td>
            <span class="ui-column-title">Referral Bonus</span>
            <div *ngFor="let pb of referral.payrollBonuses">
              <i *ngIf="!pb.payPeriodLocked && canManage" class="fas fa-redo pointer" title="Redo referral bonus calculation" (click)="redoReferralBonus(pb)"></i>
              <i *ngIf="pb.payPeriodLocked" class="fal fa-lock" title="Pay period locked"></i>
              {{pb.payrollEndDate | date: 'MM/dd/yyyy'}}
              <i *ngIf="!pb.payPeriodLocked && canManage" class="fas fa-times-circle text-danger pointer" title="Remove referral bonus" (click)="removeReferralBonus(pb)"></i>
            </div>
            <div *ngIf="referral.rejectionDate" title="{{referral.rejectionDate | date: 'MM/dd/yyyy @ h:mm:ss a'}}">
              <span style="cursor: default; font-weight: bold; font-style:italic;">
                Rejected <i class="fas fa-undo btn-link" (click)="resetReferralBonus(referral)" style="cursor: pointer;" title="Undo rejection"></i>
              </span><br />
              <span style="cursor: default; font-size: 0.95em;">
                {{referral.rejectionReason}}
              </span>
            </div>
            <div *ngIf="referral.showRejectionReason">
              <textarea rows="3" [(ngModel)]="referral.rejectionReason" [ngModelOptions]="{standalone: true}" placeholder="Please enter a reason for rejecting..."></textarea><br />
              <button class="btn btn-link" (click)="rejectReferralBonus(referral)" title="Save">
                <i class="fas fa-check"></i>
              </button>
              <button class="btn btn-link" title="Cancel" (click)="toggleRejectionReason(referral)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </td>
          <td>
            <span class="ui-column-title">Actions</span>
            <div *ngIf="referral.archivedDate == null && canManage" style="display: inline-flex;">
              <button class="btn btn-link mr-2" style="color: green; padding: 0;" (click)="addReferralBonus(referral)" title="Award new referral bonus to next unlocked pay period">
                <i class="fas fa-hand-holding-usd" style="font-size: x-large"></i>
              </button>
              <button class="btn btn-link mr-2" style="color: red; padding: 0;" (click)="toggleRejectionReason(referral)" title="Reject referral bonus">
                <i class="fas fa-frown-open" style="font-size: x-large"></i>
              </button>
              <button class="btn btn-link mr-2" style="padding: 0;" (click)="toggleArchivedReason(referral)" title="Archive Referral">
                <i class="fas fa-trash-alt" style="font-size: x-large"></i>
              </button>
            </div>

            <div *ngIf="referral.archivedDate" title="{{referral.archivedDate | date: 'MM/dd/yyyy @ h:mm:ss a'}}">
              <span style="cursor: default; font-weight: bold; font-style:italic;">
                Archived <i *ngIf="canManage" class="fas fa-undo btn-link" (click)="toggleArchived(referral)" style="cursor: pointer;" title="Unarchive Referral"></i>
              </span><br />
              <span style="cursor: default; font-size: 0.95em;">
                {{referral.archivedReason}}
              </span>
            </div>
            <div *ngIf="referral.showArchivedReason">
              <textarea rows="3" [(ngModel)]="referral.archivedReason" [ngModelOptions]="{standalone: true}" placeholder="Please enter a reason for archiving..."></textarea><br />
              <button class="btn btn-link" (click)="toggleArchived(referral)" title="Save">
                <i class="fas fa-check"></i>
              </button>
              <button class="btn btn-link" title="Cancel" (click)="toggleArchivedReason(referral)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</form>

<app-edit-referral></app-edit-referral>
